var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      ref: "cargoDialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FinanceManage.AccountingVoucher"),
        width: "1020px",
        "close-on-click-modal": false,
        "show-close": false,
        "can-minimize": true,
        "only-can-minimize": true,
        "custom-class": "accounting-entry-window"
      },
      on: { close: _vm.cancelHandler }
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VoucherLetter")))
            ]),
            _vm.isExt && _vm.isEdit
              ? _c(
                  "span",
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px" },
                        attrs: { no: "1" },
                        model: {
                          value: _vm.accountingDocument.prefix,
                          callback: function($$v) {
                            _vm.$set(_vm.accountingDocument, "prefix", $$v)
                          },
                          expression: "accountingDocument.prefix"
                        }
                      },
                      _vm._l(_vm.prefixDataProvider, function(item) {
                        return _c("el-option", {
                          key: item.uuid,
                          attrs: {
                            label:
                              _vm.$store.getters.language === "zh"
                                ? item.prefix
                                : item.prefix,
                            value: item.prefix
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.accountingDocument.prefix))
                ])
          ]),
          _c("div", { staticStyle: { "margin-top": "5px" } }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VoucherNo")))]),
            _vm.isExt && _vm.isEdit
              ? _c(
                  "span",
                  [
                    _c("el-input", {
                      staticStyle: { width: "100px" },
                      attrs: { no: "2" },
                      model: {
                        value: _vm.accountingDocument.documentNo,
                        callback: function($$v) {
                          _vm.$set(_vm.accountingDocument, "documentNo", $$v)
                        },
                        expression: "accountingDocument.documentNo"
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "span",
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px" },
                        attrs: { no: "3" },
                        model: {
                          value: _vm.curIndex,
                          callback: function($$v) {
                            _vm.curIndex = $$v
                          },
                          expression: "curIndex"
                        }
                      },
                      _vm._l(_vm.voucher, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { value: index, label: item.documentNo }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
          ])
        ]),
        _c("div", { staticClass: "center" }, [
          _c("h1", [
            _vm._v(
              " " + _vm._s(_vm.$t("CargoMsg.Cargo_BookKeepingVoucher")) + " "
            )
          ]),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ProofDateP")))]),
              _vm.isExt && _vm.isEdit
                ? _c("el-date-picker", {
                    staticStyle: { width: "100px" },
                    attrs: {
                      no: "4",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      editable: false,
                      clearable: false
                    },
                    model: {
                      value: _vm.accountingDocument.documentDate,
                      callback: function($$v) {
                        _vm.$set(_vm.accountingDocument, "documentDate", $$v)
                      },
                      expression: "accountingDocument.documentDate"
                    }
                  })
                : _c("span", [_vm._v(_vm._s(_vm.documentDate))])
            ],
            1
          )
        ]),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "flex-end" } },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEdit,
                      expression: "!isEdit"
                    }
                  ],
                  staticStyle: {
                    "text-align": "right",
                    "margin-left": "30px",
                    "margin-top": "5px"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OppositeVoucherNoP")))]
              ),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isEdit,
                    expression: "!isEdit"
                  }
                ],
                staticStyle: { "margin-right": "5px", width: "100px" },
                attrs: { disabled: true, no: "5" },
                model: {
                  value: _vm.accountingDocument.targetDocumentNo,
                  callback: function($$v) {
                    _vm.$set(_vm.accountingDocument, "targetDocumentNo", $$v)
                  },
                  expression: "accountingDocument.targetDocumentNo"
                }
              }),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.preview,
                      expression: "!preview"
                    }
                  ],
                  attrs: { type: "primary", disabled: _vm.isEdit, no: "6" },
                  on: { click: _vm.editTargetDocumentNoClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "10px" } },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Attachment")))]),
              _vm.isExt && _vm.isEdit
                ? _c("el-input", {
                    staticStyle: { width: "65px" },
                    attrs: { disabled: !_vm.isExt || !_vm.isEdit, no: "7" },
                    model: {
                      value: _vm.accountingDocument.sourceDocument,
                      callback: function($$v) {
                        _vm.$set(_vm.accountingDocument, "sourceDocument", $$v)
                      },
                      expression: "accountingDocument.sourceDocument"
                    }
                  })
                : _c("span", [
                    _vm._v(_vm._s(_vm.accountingDocument.sourceDocument))
                  ])
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.accountingEntryRowData,
              "show-side-bar": false,
              "min-height": "260px"
            }
          }),
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c("div", { staticStyle: { width: "100%" } }),
            _c(
              "div",
              {
                staticClass: "inner-row-border-bottom",
                staticStyle: {
                  width: "360px",
                  display: "flex",
                  "justify-content": "flex-start",
                  "text-align": "right",
                  "margin-top": "0px"
                }
              },
              [
                _c("div", { staticStyle: { width: "50px" } }, [
                  _c("span", { staticStyle: { "font-size": "13px" } }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("CargoMsg.Cargo_GrandTotal")) + " "
                    )
                  ])
                ]),
                _c("div", { staticStyle: { width: "120px" } }, [
                  _c("span", { staticStyle: { "font-size": "13px" } }, [
                    _vm._v(" " + _vm._s(_vm.debitTotal) + " ")
                  ])
                ]),
                _c("div", { staticStyle: { width: "120px" } }, [
                  _c("span", { staticStyle: { "font-size": "13px" } }, [
                    _vm._v(" " + _vm._s(_vm.creditTotal))
                  ])
                ])
              ]
            )
          ]),
          _c(
            "fieldset",
            [
              _c("legend", [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_SubsidiaryAccountingItems"))
                )
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": "80px",
                    disabled: !_vm.isExt || !_vm.isEdit
                  }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Customer")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  no: "8",
                                  "default-value": _vm.txtCustomerExt,
                                  "method-params": {},
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: _vm.customerExtChangeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Vendor") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  no: "9",
                                  "default-value": _vm.txtCustomerExt2,
                                  "method-params": {},
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: _vm.customerExtChangeHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Staff") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .static_data_MappingStaff,
                                  filterable: "",
                                  no: "10",
                                  cache: false,
                                  "default-value": _vm.curRowData.staffId,
                                  placeholder: " ",
                                  "static-options": _vm.mappingStaffs
                                },
                                on: { parentCallBack: _vm.staffChangeHandler }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Department")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .static_data_MappingDepartment,
                                  filterable: "",
                                  no: "11",
                                  cache: false,
                                  "default-value": _vm.curRowData.department,
                                  placeholder: " ",
                                  "static-options": _vm.mappingDepartments,
                                  "custom-label": _vm.departmentLabelFun
                                },
                                on: {
                                  parentCallBack: function(department) {
                                    return (_vm.curRowData.department =
                                      department.departmentId)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Salesman")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_User,
                                  filterable: "",
                                  no: "12",
                                  "default-value": _vm.curRowData.sales,
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role",
                                    shape: "sales"
                                  },
                                  placeholder: " "
                                },
                                on: { parentCallBack: _vm.saleChangeHandler }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_ItemNoP") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "13" },
                                model: {
                                  value: _vm.curRowData.projectNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.curRowData,
                                      "projectNumber",
                                      $$v
                                    )
                                  },
                                  expression: "curRowData.projectNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ItemNo2P")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "14" },
                                model: {
                                  value: _vm.curRowData.projectNumber2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.curRowData,
                                      "projectNumber2",
                                      $$v
                                    )
                                  },
                                  expression: "curRowData.projectNumber2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_BusinessHappenDateP"
                                ),
                                "label-width": "90px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "135px" },
                                attrs: {
                                  no: "15",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.curRowData.businessDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.curRowData,
                                      "businessDate",
                                      $$v
                                    )
                                  },
                                  expression: "curRowData.businessDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.preview && !_vm.isEdit,
                      expression: "!preview && !isEdit"
                    }
                  ],
                  staticStyle: { width: "70px" },
                  attrs: { type: "primary", no: "16" },
                  on: {
                    click: function($event) {
                      return _vm.handleMoveIndex("first")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_1St")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.preview && !_vm.isEdit,
                      expression: "!preview && !isEdit"
                    }
                  ],
                  staticStyle: { width: "70px", "margin-left": "5px" },
                  attrs: { type: "primary", no: "17" },
                  on: {
                    click: function($event) {
                      return _vm.handleMoveIndex("pre")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheLastPage")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.preview && !_vm.isEdit,
                      expression: "!preview && !isEdit"
                    }
                  ],
                  staticStyle: { width: "70px", "margin-left": "5px" },
                  attrs: { type: "primary", no: "18" },
                  on: {
                    click: function($event) {
                      return _vm.handleMoveIndex("next")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheNextPage")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.preview && !_vm.isEdit,
                      expression: "!preview && !isEdit"
                    }
                  ],
                  staticStyle: { width: "70px", "margin-left": "5px" },
                  attrs: { type: "primary", no: "19" },
                  on: {
                    click: function($event) {
                      return _vm.handleMoveIndex("last")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheLast")))]
              ),
              _c("span", { staticStyle: { "margin-left": "40px" } }, [
                _vm._v(_vm._s("" + _vm.$t("CargoMsg.Cargo_PreparedBy")))
              ]),
              _c(
                "span",
                {
                  staticStyle: { "font-weight": "bold", "margin-left": "10px" }
                },
                [_vm._v(_vm._s("" + _vm.documentMaker))]
              ),
              _c("span", { staticStyle: { "margin-left": "30px" } }, [
                _vm._v(_vm._s("" + _vm.$t("CargoMsg.Cargo_Auditor")))
              ]),
              _c(
                "span",
                {
                  staticStyle: { "font-weight": "bold", "margin-left": "10px" }
                },
                [_vm._v(_vm._s("" + _vm.verifier))]
              )
            ],
            1
          ),
          _c(
            "div",
            [
              !_vm.preview && _vm.isExt && _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "20" },
                      on: { click: _vm.checkLossClickHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_BrokenNumberDetection"))
                      )
                    ]
                  )
                : _vm._e(),
              !_vm.preview && _vm.isExt && _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px", "margin-left": "5px" },
                      attrs: { type: "primary", no: "21" },
                      on: { click: _vm.addEntryClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddJournalEntry")))]
                  )
                : _vm._e(),
              !_vm.preview && _vm.isExt && _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px", "margin-left": "5px" },
                      attrs: {
                        type: "primary",
                        no: "22",
                        disabled: !_vm.hasSelected
                      },
                      on: { click: _vm.removeEntryClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DeleteEntry")))]
                  )
                : _vm._e(),
              _vm.auditBtnVisible && !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px", "margin-left": "5px" },
                      attrs: { type: "primary", no: "23" },
                      on: { click: _vm.auditHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Audit")))]
                  )
                : _vm._e(),
              _vm.auditBtnVisible
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px", "margin-left": "5px" },
                      attrs: { type: "primary", no: "24" },
                      on: { click: _vm.btnEditClick }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.isEdit
                            ? _vm.$t("CargoMsg.Cargo_Save")
                            : _vm.$t("CargoMsg.Cargo_Edit")
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticStyle: { width: "70px", "margin-left": "5px" },
                  attrs: { no: "25" },
                  on: { click: _vm.cancelHandler }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.isEdit
                        ? _vm.$t("CargoMsg.Cargo_Cancel")
                        : _vm.$t("CargoMsg.Cargo_Close")
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("account-entry-charge-detail-window", {
        ref: "accountingEntryCharge",
        attrs: { visible: _vm.accountingEntryChargeDetailWindow.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(
              _vm.accountingEntryChargeDetailWindow,
              "visible",
              $event
            )
          },
          close: _vm.closeChargeDetailWindow
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }